import React from 'react'

import Container from '../../../components/structure/Container'
import ExecutionForm from './ExecutionForm'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Footer from './Footer'
import PageHeader from './PageHeader'
import Separator from '../../../components/helpers/Separator'
import ImperativeComponents from '../../../containers/dynamic/form/replies/context/ImperativeComponentsContext'

const ExecutionPageContent = () => {
  return (
    <ImperativeComponents>
      <PageHeader />
      <Separator weight={4} />
      <FlexGrid align="stretch">
        <FlexCol flex={1} noMargin noRadius hideOn="mdd" />
        <Separator weight={4} vertical hideOn="mdd" />
        <FlexCol flex={4}>
          <Container maxWidth="44rem">
            <ExecutionForm />
            <Footer />
          </Container>
        </FlexCol>
        <Separator weight={4} vertical hideOn="mdd" />
        <FlexCol flex={1} noMargin noRadius hideOn="mdd" />
      </FlexGrid>
      <Separator weight={32} />
    </ImperativeComponents>
  )
}

export default ExecutionPageContent
